
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies_policy",
      function () {
        return require("private-next-pages/cookies_policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookies_policy"])
      });
    }
  